module.exports = __webpack_public_path__ + "img/normal_multiplier.73e3755f.png";